import React from 'react'

import Sidebar from './Sidebar'

const Layout = ({ children }) => {

  return (
    <div className='flex-layout'>
      <Sidebar />
      <div className='wrapper'>
        {children}
      </div>
    </div>
  )
}

export default Layout
